import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LocalizationService } from 'src/app/service/localization.service';
import { JsonKey } from 'src/app/data/type/locale-copy-key';
import { getVoiceIntroCopy } from 'src/app/utils/localization';
import { VoiceSearchFeature } from 'src/app/page/voice-search-page/voice-search-page.types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-c09-voice-intro-screen',
  templateUrl: './c09-voice-intro-screen.component.html',
  styleUrls: ['./c09-voice-intro-screen.component.scss'],
})
export class c09VoiceIntroScreenComponent implements OnInit {
  @Input() isLoading: Boolean;
  @Input() isListening: Boolean;
  @Input() speechResult: string;
  @Input() isSttEnabled: boolean;
  @Input() disableIntroButtons: boolean = true;
  @Input() isModal: boolean;

  @Output() buttonClick = new EventEmitter<VoiceSearchFeature>();

  constructor(private localizationService: LocalizationService) {}

  public baseHref = environment.baseHref;
  public jsonKey = JsonKey;
  public copy = {
    [JsonKey.VOICE_INTRO_PLEASE_WAIT]: '',
    [JsonKey.VOICE_INTRO_TRY_SAYING_COPY]: '',
    [JsonKey.VOICE_INTRO_CHOOSE_ONE_COPY]: '',
    featureTitles: {
      [VoiceSearchFeature['action-movies']]: '',
      [VoiceSearchFeature['lights']]: '',
      [VoiceSearchFeature['children-shows']]: '',
      [VoiceSearchFeature['front-door']]: '',
    },
  };

  public voiceSearchButtons = [
    VoiceSearchFeature['action-movies'],
    VoiceSearchFeature['lights'],
    VoiceSearchFeature['children-shows'],
    VoiceSearchFeature['front-door'],
  ];

  ngOnInit(): void {
    this.copy = getVoiceIntroCopy(this.localizationService);
  }

  onButtonClick(feature: VoiceSearchFeature) {
    this.buttonClick.emit(feature);
  }
}
